"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableLoadingState = TableLoadingState;
var jsx_runtime_1 = require("react/jsx-runtime");
var loader_1 = require("../loader");
function TableLoadingState(props) {
    var label = props.label;
    return ((0, jsx_runtime_1.jsx)("div", { className: "flex items-center justify-center py-24", children: (0, jsx_runtime_1.jsx)(loader_1.Loader, { variant: "inline", size: "md", label: label }) }));
}
